<template>
  <div>
    <el-table
      v-loading="loading"
      :data="items"
      size="small"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        prop="name"
        label="Title"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        prop="stream_title"
        label="Stream"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        prop="type_title"
        label="Format"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        prop="spots_count"
        label="Spots count"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        v-if="hasActions"
        align="center"
        label="Actions"
        prop="action"
      >
        <template #default="{ row }">
          <el-tooltip class="item" placement="top-start" content="Edit list">
            <el-button
              type="success"
              size="small"
              circle
              plain
              icon="EditElementIcon"
              @click="trigger('edit', row.id)"
            />
          </el-tooltip>
          <el-tooltip class="item" placement="top-start" content="Clone list">
            <el-button
              type="primary"
              size="small"
              circle
              plain
              icon="CopyDocumentElementIcon"
              @click="trigger('clone', row.id)"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            placement="top-start"
            content="Archive"
          >
            <el-popconfirm
              confirm-button-text="OK"
              cancel-button-text="No, Thanks"
              confirm-button-type="danger"
              icon="InfoFilledElementIcon"
              icon-color="red"
              :title="destroyTitle(row.attributes)"
              @confirm="trigger('destroy', row.id)"
            >
              <template #reference>
                <el-button
                  type="info"
                  plain
                  circle
                  size="small"
                  icon="FilesElementIcon"
                />
              </template>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import useResize from '@/hooks/useResize'
import formatter from '@/utils/table'
import { useSpotsListsStore } from '@/apps/traforama/store/spotsLists'
import {
  ISpotsList,
  ISpotsListAttributes
} from '@/apps/traforama/interfaces/spotsLists'

export default defineComponent({
  name: 'ItemsTable',
  components: {},
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasActions: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const spotsListsStore = useSpotsListsStore()
    const { isDesktop } = useResize()

    const handleSelectionChange = (items: Array<ISpotsList>) => {
      spotsListsStore.SetSelection(items)
    }

    const destroyTitle = (row: ISpotsListAttributes) => {
      if (row.campaigns && row.campaigns.length) {
        return `You use this list on the campaigns: ${row.campaigns.join(', ')}.\n
        Are you sure you want to archive the lists?\n
        After archivation this list will be removed from the campaigns as a block or white list.\n
        You can't undo this action.`
      }
      return "Are you sure you want to archive the lists? You can't undo this action"
    }

    const trigger = (action: string, id: string) => {
      context.emit(action, id)
    }
    return {
      isDesktop,
      formatter,
      trigger,
      handleSelectionChange,
      destroyTitle
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-tooltip.item) {
  margin-left: 10px;
}
</style>
